export const FONT_WEIGHT_MEDIUM = 400;

export enum FontType {
  Body = 'body',
  Headline = 'headline',
}
